export default __webpack_public_path__ + "static/media/Leggings of the Kozak Slayer.066c0a1c.jpg";